import {usersReducer, UsersState} from "./reducers/users.reducer";
import {ActionReducer, ActionReducerMap, MetaReducer} from "@ngrx/store";
import {environment} from "../../../environments/environment";
import {rolesReducer, RolesState} from "./reducers/roles.reducer";
import {dashboardCaseFilesReducer, DashboardCaseFilesState} from "./reducers/dashboard.reducer";
import {fiusReducer, FiusState} from "./reducers/fius.reducer";
import {caseEntitiesReducer, CaseEntitiesState} from "./reducers/case-entities.reducer";
import {workingGroupsReducer, WorkingGroupsState} from "./reducers/working-groups.reducer";
import {relatedCasesReducer, RelatedCasesState} from "./reducers/related-cases.reducers";
import {notificationsReducer, NotificationsState} from "./reducers/notifications.reducer";
import {documentReducer, DocumentState} from "./reducers/document.reducer";
import {countriesReducer, CountriesState} from "./reducers/countries.reducer";

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action) {
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}

export interface State {
  users: UsersState;
  roles: RolesState;
  dashboardCaseFiles: DashboardCaseFilesState,
  fius: FiusState,
  caseEntities: CaseEntitiesState,
  workingGroups: WorkingGroupsState,
  relatedCases: RelatedCasesState,
  notifications: NotificationsState,
  document: DocumentState,
  countries: CountriesState
}

export const reducers: ActionReducerMap<State> = {
  users: usersReducer,
  roles: rolesReducer,
  dashboardCaseFiles: dashboardCaseFilesReducer,
  fius: fiusReducer,
  caseEntities: caseEntitiesReducer,
  workingGroups: workingGroupsReducer,
  relatedCases: relatedCasesReducer,
  notifications: notificationsReducer,
  document: documentReducer,
  countries: countriesReducer,
};


export const metaReducers: MetaReducer<State>[] = !environment.production ? [debug] : [];
